import React from 'react';
import { Badge } from '../ui/badge';
import type { SourcePermissionBadge } from '../../types/libraryProvenance';
import { permissionBadgeClass, permissionBadgeLabel } from '../../utils/sourcePermissions';
import { cn } from '../../lib/utils';

interface SourcePermissionBadgesProps {
  badges: SourcePermissionBadge[];
  className?: string;
  size?: 'sm' | 'xs';
}

export const SourcePermissionBadges: React.FC<SourcePermissionBadgesProps> = ({
  badges,
  className,
  size = 'xs',
}) => {
  if (!badges.length) return null;

  return (
    <div className={cn('flex flex-wrap gap-1', className)} data-testid="source-permission-badges">
      {badges.map((badge) => (
        <Badge
          key={badge}
          variant="outline"
          className={cn(
            'font-normal',
            size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs',
            permissionBadgeClass(badge)
          )}
        >
          {permissionBadgeLabel(badge)}
        </Badge>
      ))}
    </div>
  );
};

export default SourcePermissionBadges;
